interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  label?: string;
  className?: string;
  showLabel?: boolean;
}

/**
 * Reusable loading spinner component with accessibility support
 */
export function LoadingSpinner({
  size = 'md',
  label = 'Loading...',
  className = '',
  showLabel = false
}: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: 'h-4 w-4 border-2',
    md: 'h-8 w-8 border-3',
    lg: 'h-12 w-12 border-4'
  };

  return (
    <div className={`flex flex-col items-center justify-center ${className}`}>
      <div
        className={`${sizeClasses[size]} border-gray-200 dark:border-gray-700 border-t-blue-600 rounded-full animate-spin`}
        role="status"
        aria-label={label}
        aria-live="polite"
      >
        <span className="sr-only">{label}</span>
      </div>
      {showLabel && (
        <p className="mt-4 text-gray-600 dark:text-gray-400 text-sm">{label}</p>
      )}
    </div>
  );
}
